<div class="re-container-headline re-mb-30 md:re-mb-60">
  <h3 data-qa="title">
    {{ (hasOfferContext ? 'offer.situation.title' : 'delivery.situation.title') | translate }}
  </h3>
</div>

<form [formGroup]="situationForm" (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()"
  bdoScrollToInvalidControl novalidate [attr.aria-label]="'aria.form.deliverySituation' | translate">

  <div class="re-bg-white re-w-full re-p-20 re-pt-30 re-pb-45 re-mb-30
              md:re-w-600 md:re-pt-45 md:re-pb-60 md:re-mx-auto
              lg:re-w-900">
    <fieldset name="delivery-situation" class="re-mb-0">
      @if (!offerContext) {
      <h5>{{ 'delivery.situation.subtitleRegistration' | translate}}</h5>

      <div class="re-flex re-items-start re-mt-30">
        <input id="CHANGE" type="radio" value="CHANGE" name="deliveryMethod" formControlName="deliveryMethod">
        <label for="CHANGE" class="re-ml-15">
          <span class="bold">{{ 'delivery.situation.selection.change.title' | translate }}</span>
          <div>{{ 'delivery.situation.selection.change.description' | translate }}</div>
        </label>
      </div>

      <div class="re-flex re-items-start re-mt-30">
        <input id="MOVE" type="radio" value="MOVE" name="deliveryMethod" formControlName="deliveryMethod">
        <label for="MOVE" class="re-ml-15">
          <span class="bold">{{ 'delivery.situation.selection.move.title' | translate }}</span>
          <div>{{ 'delivery.situation.selection.move.description' | translate }}</div>
        </label>
      </div>

      <div class="re-flex re-items-start re-mt-30 re-mb-45">
        <input id="wrongProcess" type="radio" value="wrongProcess" name="deliveryMethod"
          formControlName="deliveryMethod">
        <label for="wrongProcess" class="re-ml-15">
          <span class="bold">{{ 'delivery.situation.selection.wrongProcess.title' | translate }}</span>
          <div>{{ 'delivery.situation.selection.wrongProcess.description' | translate }}</div>
        </label>
      </div>
      }

      @if (situationForm.get('deliveryMethod')?.value !== 'wrongProcess') {
        @if (!isStateMove() && (!isReacquisition || offerContext === null)) {
        <div [attr.data-qa]="'termination'" class="re-mb-15">
          <div class="bold re-mb-30
                      md:re-mb-20 md:re-text-base md:re-leading-2xl">
            {{ 'delivery.situation.terminateTitle' | translate: { division: supply } }}
          </div>
          <div class="re-flex re-items-start re-relative re-mb-20">
            <input id="auto" type="radio" class="" value="auto" name="termination" formControlName="termination"
              data-qa="radio-termination-auto">
            <label class="re-ml-15" for="auto">
              {{ 'delivery.situation.withCancel' | translate:
              { companyName: reBaseData.companyName, division: supply } }}
            </label>
          </div>
          <div class="re-flex re-items-start re-relative">
            <input id="self" type="radio" class="" value="self" name="termination" formControlName="termination"
              data-qa="radio-termination-self">
            <label class="re-ml-15" for="self">{{ 'delivery.situation.alreadyCanceled' | translate:
              { division: supply } }}
            </label>
          </div>
        </div>
        }
        <!-- Autosuggest  -->
        @if (!isStateMove() && situationForm.get('previousSupplier') && (situationForm.get('termination')?.value ===
        'auto' || isReacquisition)) {
        <div class="re-mb-45 re-relative">
          <bdo-input [formControl]="$any(situationForm.get('previousSupplier'))" ngDefaultControl
            [inputType]="inputTypeMappings.previousSupplier" [validationIconHidden]="state === LoadingState.ERROR"
            [labelText]="'delivery.situation.details.previousSupplier' | translate"
            (blur)="trackInvalid('previousSupplier')" [enableAutocomplete]="true" #previousSupplier>
          </bdo-input>
          <bdo-autosuggest [dataSource$]="suppliers$" [searchString$]="searchString$" [for]="previousSupplier"
            [sort]="sortAutosuggest" (noItemsAvailable)="noSupplierAvailable$.next($event)"
            (itemSelected)="onItemSelected($event)">
          </bdo-autosuggest>
        </div>
        }
        <div class="md:re-text-base md:re-leading-2xl">
          <div class="bold re-mt-45"> {{ 'delivery.situation.details.meterNumber' | translate }}
          </div>
        </div>
        <div class="re-mt-20 re-mb-45">
          <bdo-meter-number [parentForm]="situationForm" [withRegisters]="isStateMove()"
            [deliveryType]="deliveryType" [readingsOptional]="true" [sparte]="divisionId"
            [storedMeterData]="storedMeterData" [address]="address" (meterCheckResult)="onMeterCheckResult($event)">
          </bdo-meter-number>
        </div>
        <div class="re-relative">
          <div>
            <div class="md:re-text-base md:re-leading-2xl re-mb-20">
              <div class="bold re-mt-45"> {{ 'delivery.situation.details.startDateTitle' | translate }}
              </div>
            </div>
            <bdo-date-picker [selectedDate]="situationForm?.get('startDate').value"
              (dateSelected)="updateDate($event, true)" [minDateForChanges]="minDate" [maxDateForChanges]="maxDate"
              [noPreselection]="true" [labelText]="'delivery.situation.details.startDate' | translate"
              [tooltipName]="'delivery-date-info'"
              [tooltipContent]="'delivery.situation.details.startDateHint' | translate"
              [attr.data-qa_mindateforchanges]="minDate"
              [attr.data-qa_selecteddate]="situationForm?.get('startDate').value">
            </bdo-date-picker>

            @if (isReacquisition) {
            <div class="re-mt-45" [formGroup]="situationForm">
              <bdo-checkbox [checked]="situationForm.get('revocationWanted')?.value"
                (change)="situationForm.get('revocationWanted')?.setValue(!situationForm.get('revocationWanted')?.value)"
                data-qa="revocationWanted">
                <p [innerHTML]="'delivery.situation.revocationAutomatic' | translate"></p>
              </bdo-checkbox>
            </div>
            }
          </div>
        </div>
      } @else {
        <h5>{{ 'delivery.situation.wrongProcess.title' | translate}}</h5>
        <div>{{ 'delivery.situation.wrongProcess.description' | translate }}</div>
        <div class="re-mt-45 re-flex re-flex-col re-text-center re-flex-wrap re-justify-between md:re-flex-row">
          <a class="bdo-button-primary re-min-w-200 re-mb-15 md:re-mb-0"
            [routerLink]="['/vertrag']"
            [queryParams]="{ division: tariffData?.divisionId }"
            queryParamsHandling="merge">
          {{ 'delivery.situation.wrongProcess.ctaChangeTariff' | translate }}
        </a>
        <a [routerLink]="'/anmelden'" class="bdo-button-primary re-min-w-200">
          {{ 'delivery.situation.wrongProcess.ctaNewContract' | translate }}
        </a>
        </div>
      }
    </fieldset>
  </div>

  @if (situationForm.get('deliveryMethod')?.value !== 'wrongProcess') {
    <div class="re-mx-20
                md:re-w-600 md:re-mx-auto
                lg:re-w-900">
      <bdo-validate-submit
        [isContextSummary]="context === CONTEXT_FROM_SUMMARY"
        [textButtonLong]="'wizard.button.payment' | translate"
      ></bdo-validate-submit>
    </div>
  }

</form>

<div class="re-mx-20
            md:re-w-600 md:re-mx-auto
            lg:re-w-900">
  <div class="re-pt-15">
    <bdo-text-icon
      [iconPosition]="'left'"
      [text]="'general.action.back' | translate"
      (itemClicked)="location.back()"
    ></bdo-text-icon>
  </div>
</div>
